/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse2007 from '../model/InlineResponse2007';

/**
* Certificates service.
* @module api/CertificatesApi
* @version 1.0.0
*/
export default class CertificatesApi {

    /**
    * Constructs a new CertificatesApi. 
    * @alias module:api/CertificatesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * get
     * get filtred presta certificates
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/InlineResponse2007>} and HTTP response
     */
    certificatesControllerGetPrestaCertificatesWithHttpInfo(academicProgramId) {
      let postBody = null;
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling certificatesControllerGetPrestaCertificates");
      }

      let pathParams = {
        'academicProgramId': academicProgramId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [InlineResponse2007];
      return this.apiClient.callApi(
        '/account/students/student/{academicProgramId}/presta/certificates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get
     * get filtred presta certificates
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/InlineResponse2007>}
     */
    certificatesControllerGetPrestaCertificates(academicProgramId) {
      return this.certificatesControllerGetPrestaCertificatesWithHttpInfo(academicProgramId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
